<template>
  <div class="mf-card benefit-percentage">
    <v-card-title>Utilização de {{ offerTypeName }}</v-card-title>
    <div class="pa-4">
      <v-progress-linear class="progress-bar" color="primary" :value="earnBurnPercent" :height="12" rounded></v-progress-linear>
      <div class="percentage-value">{{ earnBurnPercent }}%</div>
      <div class="percentage-subtitle">
        <div>
          <span class="value" style="opacity: 0.6">{{ earnCount }}</span>
          <span class="fixed-text"> {{ offerTypeName }} gerado</span>
        </div>
        <div>
          <span class="value">{{ burnCount }}</span>
          <span class="fixed-text"> {{ offerTypeName }} utilizado</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitProgressCard',
  props: {
    loading: Boolean,
    metrics: {
      type: Object,
      default(_) {
        return {}
      },
    },
    offerType: {
      type: String,
      validator: (value) => ['takepay', 'nextbuycashback', 'dynamic_rule', 'cashback_absolute', 'cashback_percentage'].includes(value),
    },
  },
  computed: {
    earnCount() {
      return this.metrics?.earn_metrics?.count || 0
    },
    burnCount() {
      return this.metrics?.burn_metrics?.count || 0
    },
    earnBurnPercent() {
      const percent = this.earnCount > 0 ? (this.burnCount * 100) / this.earnCount : 0
      return Number.isInteger(percent) ? percent : parseFloat(percent).toFixed(2)
    },
    offerTypeName() {
      switch (this.offerType) {
        case 'nextbuycashback':
        case 'cashback_absolute':
        case 'cashback_percentage':
          return 'cashback'
        case 'dynamic_rule':
          return 'voucher'
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.benefit-percentage {
  height: 100%;
  display: flex;
  flex-direction: column;

  .progress-bar {
    border-radius: 6px;
  }
  .percentage-value {
    margin-top: 4px;
  }
  .percentage-subtitle {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
  }
  .fixed-text {
    font-size: 14px;
    opacity: 0.6;
  }
  .value {
    font-size: 18px;
  }
}
</style>
